import React from 'react';
import Magic from '../components/magic';
import { HybirdContext, withHybird } from './HybirdContext.container';
import { useContext } from 'react';

const MagicContainer = (props) => {
  const hybirdContext = useContext(HybirdContext);
  const gotoParty = () => {
    hybirdContext.gotoCreateParty();
    hybirdContext.trackAction('GetSurprise', JSON.stringify({'link.category': 'HarmonyLanding'}));
  };
  const gotoRecords = () => {
    hybirdContext.gotoPrizeRecord();
    hybirdContext.trackAction('MySurprises', JSON.stringify({'link.category': 'HarmonyLanding'}));
  };
  return (
    <Magic {...props} onGotoParty={gotoParty} onGotoRecord={gotoRecords}/>
  )
};
export default withHybird(MagicContainer);
